import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';

// remove these constants when `getWillShowNav4` is cleaned up
// they are already defined in `navigation-kit-shortcut-menu-content`
export const SHORTCUT_MENU_ITEM_BASE_WIDTH = 360;
export const SHORTCUT_NAME_FOCUSED_WIDTH = 196;
export const SHORTCUT_MENU_OFFSET = 86;

const PACKAGE_NAME = 'jiraBusinessShortcut';

// remove this object when `getWillShowNav4` is cleaned up
export const MAIN_EXPERIENCE: ExperienceDetails = {
	experience: 'shortcut',
	experienceId: 'main',
	packageName: PACKAGE_NAME,
	teamName: 'jira-warepil',
};

export const SHORTCUT_EMBED_EXPERIENCE: ExperienceDetails = {
	experience: 'shortcutEmbed',
	packageName: PACKAGE_NAME,
	teamName: 'jira-warepil',
};
